import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getProducts = () => client.get("/products").then((r) => r.data);
export const ocrAnalyze = (payload) => client.post("/ocr/analyze", payload).then((r) => r.data);
export const createAnalysis = (payload) => client.post("/analysis", payload).then((r) => r.data);
export const getAnalysis = (id) => client.get(`/analysis/${id}`).then((r) => r.data);
export const createLead = (payload) => client.post("/leads", payload).then((r) => r.data);
export const getLeads = () => client.get("/leads").then((r) => r.data);
export const getLeadStats = () => client.get("/leads/stats").then((r) => r.data);
export const getLeadStatuses = () => client.get("/lead-statuses").then((r) => r.data);
export const updateLead = (id, payload) => client.patch(`/leads/${id}`, payload).then((r) => r.data);
export const sendChat = (payload) => client.post("/chat", payload).then((r) => r.data);

export default client;
